import 'nodelist-foreach'

export default ({
  input = document.querySelector('input[type="search"]'),
  elements = document.querySelectorAll('main > ul li'),
  no_results_nodifier = document.querySelector('.js--no_results')
} = {}) => {
  if (!input) return
  if (!elements || !elements.length) return

  input.addEventListener('keyup', update)

  return {
    destroy: () => {
      input.removeEventListener('keyup', update)
    }
  }

  function update () {
    window.requestAnimationFrame(() => {
      let number_of_elements_shown = 0;

      elements.forEach(element => {
        const should_show_elements = this.value == '' || match(this.value, element);
        if(should_show_elements) {
          element.style.display = '';
          number_of_elements_shown++;
        } else {
         element.style.display = 'none';
        }
      })

      if(number_of_elements_shown === 0) {
        no_results_nodifier.style.display = '';
      } else {
        no_results_nodifier.style.display = 'none';
      }
    })
  }

  function match (needle, element) {
    const haystack = element.innerHTML.toLowerCase()
    return needle.split(',').some(submatch => {
      if (!submatch || !submatch.trim()) return
      return ~haystack.indexOf(submatch.trim().toLowerCase())
    })
  }
}
